(function($) {

    $(document).ready(function() {
        var images = $('img');

        images.load(function() {
            var element = $(this);
            var attr = element.attr('data-retina-image-fix');
            if (this.src.match(/@2x\.(jpg|png|gif)/ig)) {

                if (element.attr('width') == 0 && element.attr('height') == 0) {
                    element.removeAttr('height');
                    element.removeAttr('width');
                }

                if (typeof attr != 'undefined') {
                    element.attr('retina-image-fix-runtime', '');
                }
            }
        });

        var eventType = typeof window.onorientationchange == 'undefined' ? 'resize' : 'orientationchange';

        $(window).on(eventType, function() {

            // обработка тех картинок которые
            // заменила ретина.жс при ресайзе.
            // так как нам нужно только для
            // особенных, full-width картинок, мы
            // можем просто оторвать у них атрибуты
            // которые выставила ретина
            // и радоваться жизни.
            $('img[retina-image-fix-runtime]').each(function(i, e) {
                $(e).removeAttr('height');
                $(e).removeAttr('width');
            });
        });

    });

})(jQuery);
